import { useRef, useMemo, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
// import { push } from 'redux-first-history';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import ButtonLink from 'Common/components/buttons/ButtonLink';
import HeaderTitle from 'Common/components/PageHeader/HeaderTitle';
import HeaderActions from 'Common/components/PageHeader/HeaderActions';
import HeaderContainer from 'Common/components/PageHeader/HeaderContainer';
import Filters from 'Common/components/filter/FiltersContainer';

import { roles } from 'User/constants/roles';
import isAuthorized from 'User/utils/isAuthorized';

import useUserListFilterData from 'UserManagement/components/UserList/hooks/useUserListFilterData';
import UserListTable from 'UserManagement/components/UserList/UserListTable';
import TabsContainer from 'Common/components/tabs';
import { updateCurrentTab } from 'Application/reducers/reduxTabs';
import UserOverlay from '../UserForm/UserOverlay';
import crudModes from 'Common/constants/crudModes';
import { AlertWrapper, BoldText, StyledLink } from 'Impact/Impact';
import Icon from 'Common/components/icons/Icon';

const UserList = () => {
	const { t } = useTranslation();
	const [isCreateOpen, setIsCreateOpen] = useState(false);

	const dispatch = useDispatch();
	const location = useLocation();

	const isEpcList = useMemo(() => (location.pathname === '/epc-users' ? 1 : 0), [location.pathname]);

	const canCreateUsers = isAuthorized([roles.ADMIN]);

	const filterButtonRef = useRef();
	const filtersData = useUserListFilterData(isEpcList);

	useEffect(() => {
		dispatch(updateCurrentTab({ tab: 'epc-users', tabIndex: isEpcList ? 1 : 0 }));
	}, [isEpcList, dispatch]);

	// const onTabSelect = useCallback(
	// 	selectedTabIndex => {
	// 		if (selectedTabIndex === 0) {
	// 			dispatch(push('/users'));
	// 		} else {
	// 			dispatch(push('/epc-users'));
	// 		}
	// 	},
	// 	[dispatch],
	// );

	const handleCreateClose = () => {
		setIsCreateOpen(false);
	};

	const tabsConfig = useMemo(
		() => [
			{
				label: 'EPC',
				PanelComponent: UserListTable,
				panelProps: {
					key: 'epc',
					isEPConly: true,
				},
			},
		],
		[],
	);

	return (
		<>
			<Helmet>
				<title>{t('Ecoligo Users')}</title>
			</Helmet>

			<HeaderContainer>
				<HeaderTitle>{t('Users')}</HeaderTitle>
				<HeaderActions>
					<div ref={filterButtonRef}></div>
					{canCreateUsers && (
						<ButtonLink
							label="Create User - Users"
							type="submit"
							onClick={() => setIsCreateOpen(true)}
							text={t('Create User')}
							icon="addRounded"
						/>
					)}
				</HeaderActions>
			</HeaderContainer>
			<AlertWrapper>
				<Icon icon="warning" size="small" />
				<h2>
					{t('As of today, ')}
					<BoldText>Pulse will be in frozen state. </BoldText>
					{t("This means that you won't be able to enter or edit any information until Pulse v2 is released. ")}
					<StyledLink
						href="https://www.notion.so/ecoligo/Pulse-migration-All-you-need-to-know-2572e2e27e4080678bf7f28ade021b6c"
						target="_blank"
						rel="noopener noreferrer"
					>
						{t('Read more ')}
					</StyledLink>
					{t('about this.')}
				</h2>
			</AlertWrapper>
			{isEpcList ? (
				<Filters key={0} table="users" buttonRef={filterButtonRef} filtersData={filtersData} />
			) : (
				<Filters key={1} table="epcUsers" buttonRef={filterButtonRef} filtersData={filtersData} />
			)}

			<TabsContainer page={'users'} tabsConfig={tabsConfig} />

			<UserOverlay
				isOpen={isCreateOpen}
				mode={crudModes.CREATE}
				onClose={handleCreateClose}
				onFormSubmit={() => {}}
			/>
		</>
	);
};

export default UserList;
